export const SHOW_TOAST_EVENT = "show-toast";

export const showToast = ({
  type = "success",
  message = "",
  timeout = 3000,
  dismissible = "true",
  onClose = undefined,
}) => {
  const event = new CustomEvent(SHOW_TOAST_EVENT, {
    detail: { message, type, timeout, dismissible, onClose },
  });
  window.dispatchEvent(event);
};

export const showSuccessToast = (message, config) => {
  showToast({ message, ...config });
};

export const showErrorToast = (message, config) => {
  showToast({ message, type: "error", ...config });
};

export const showGeneralToast = (message, config) => {
  showToast({ message, type: "general", ...config });
};

export const showWarningToast = (message, config) => {
  showToast({ message, type: "warning", ...config });
};
